import { curry, pipe } from 'rambda';
import footerConnnector from 'services/connect/footerConnector';
import setFooterData from 'services/decorator/footer/setFooterData';
import constants from 'constants/actions';
import { localStorageCacheDecorator } from '../app/cacheHelper';

const then = curry((f, p) => p.then(f));

const getFooterDataHandler = pipe(footerConnnector, then(setFooterData));
const cachedGetFooterDataHandler = (args) => localStorageCacheDecorator({ func: getFooterDataHandler, options: { storageKey: 'FOOTER_CACHE', cacheTimeConfigKey: 'footerCaching' }, args });

const getFooterData = () => {
    return async (dispatch) => {
        const response = await cachedGetFooterDataHandler();
        const { payload = {} } = response;
        dispatch({
            type: constants.FOOTER.GET_FOOTER,
            payload
        });
    };
};

export default getFooterData
